export const ALL_GOALS_ID = 'allGoals'
export const allGoals = { uid: ALL_GOALS_ID, displayName: 'All goals' }
